import React, { FC, memo } from "react";

import { IContactPerson } from "@/data/consultant-profiles";
import { Flex } from "@/eworkitComponents";
import { ContactPerson } from "@/views/components/Contact/ContactPerson";
import { Avatar } from "@/views/components/Person";

export interface IContactPersonDetailCard {
  contactPerson: IContactPerson;
}

export const ContactPersonDetail: FC<IContactPersonDetailCard> = memo(({ contactPerson }) => {
  return (
    <Flex innerMargin="md">
      <Flex>
        <Avatar
          firstName={contactPerson.firstName}
          lastName={contactPerson.lastName}
          avatar={contactPerson.avatar}
          size="xl"
        />
      </Flex>

      <Flex direction="column" innerMargin="xs">
        <ContactPerson contactPerson={contactPerson} hasIcon={false} />
      </Flex>
    </Flex>
  );
});
